export default String.raw`
{% if cart.SelectedDelivery.PhoneRequired -%}
    <div class="cart__info-bar warning-bar">
        <svg>
            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#headset-{{settings.iconStyle}}"></use>
        </svg>
        {{translations.LackOfPhone}}
    </div>
{% endif -%}

<div class="addresses-list-js">
    <div class="cart-addresses-list">
        {% assign selectedAddress = false -%}
        {% for address in customer.DeliveryAddresses -%}
            {% include 'partials/cart/delivery-partials/address-list-item.html' with address -%}
        {% endfor -%}
    </div> 
        
    <button class="primary-action-button cart__save-btn confirm-change-address-js" data-next-step="{{nextStep}}">
        {{translations.ButtonSave}}
    </button>

    <div class="cart__popup cart-popup-js cart-customer-address-popup-js hidden-js">
        <div class="cart__popup-box cart-customer-address">
            <div class="cart__popup-header">
                <div class="cart__popup-title">
                    <span class="cart-edit-customer-address-new-js hidden-js">{{ translations.NewAddress }}</span>
                    <span class="cart-edit-customer-address-edit-js hidden-js">{{ translations.EditAddress }}</span>
                </div>
            </div>
            <div class="cart__popup-content cart-customer-address-popup-content-js"></div>
        </div>
    </div>
</div>
`